import React from "react";
import "./index.css";
import { BackButton } from "../backButton";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div className={"error-boundary"}>
          <div className={"error-title"}>Some errors occur in the page</div>
          <div className={"help-info"}>
            Sorry, something went wrong. Please contact{" "}
            <span style={{ fontWeight: 600 }}>compliance-engineering-support@thoughtworks.com</span>
          </div>
          <BackButton />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
